import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const QuickLinksConfigurationContext = createContext({ onClick: () => undefined });
export const QuickLinksProvider = ({ children, onClick }) => {
    return (_jsx(QuickLinksConfigurationContext.Provider, { value: { onClick }, children: children }));
};
export const useQuickLinksConfiguration = () => {
    return useContext(QuickLinksConfigurationContext);
};
//# sourceMappingURL=QuickLinksConfigurationContext.js.map